// @flow
import $ from "jquery";
import { fetchImage } from "services/imagesPrefetcher";
import { getFileDataForId } from "../uploadFileMethods";

/**
 * in case upload is File then run validate. if url, try to load first and then run validate
 * !! cant use async/await here because cant have native promises returned !!!
 */
export default (data: Object, context: Object, validator: Function, options) => {
	const dfd = $.Deferred();
	const file = data.files[0];

	if (typeof (file) === "object") {
		if (data.img) {
			validator(data.img, dfd);
		} else {
			dfd.resolveWith(context, [data]);
		}
	} else if (typeof (file) === "string") { // attempt to load the image from url

		const fileData = getFileDataForId(data.uniqueId, options);

		if (fileData.fetchImageDimensions) {
			const { width: naturalWidth, height: naturalHeight } = fileData.fetchImageDimensions;
			validator({ naturalWidth, naturalHeight }, dfd);
		}
		else {
			fetchImage(file, file)
				.then((result) => {
					if (result.success) {
						validator(result.img, dfd);
					} else {
						dfd.resolveWith(context, [data]); // failed to load from url
					}
				});
		}
	}

	return dfd.promise();
};
// const validateImageForUpload =
